import { render, staticRenderFns } from "./authWrapper.vue?vue&type=template&id=bda82c2a&scoped=true&"
import script from "./authWrapper.vue?vue&type=script&lang=js&"
export * from "./authWrapper.vue?vue&type=script&lang=js&"
import style0 from "./authWrapper.vue?vue&type=style&index=0&lang=css&"
import style1 from "./authWrapper.vue?vue&type=style&index=1&id=bda82c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda82c2a",
  null
  
)

export default component.exports